"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SnackBar = void 0;
var React = require("react");
var styled_components_1 = require("styled-components");
var Theme_1 = require("../../Theme");
var fadeInSlideUp = styled_components_1.keyframes(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    from {\n        opacity: 0;\n        transform: translateY(20%);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n"], ["\n    from {\n        opacity: 0;\n        transform: translateY(20%);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n"])));
var Container = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    min-height: 32px;\n    ", "\n    border-radius: 5px;\n    justify-content: space-between;\n    overflow: auto;\n    animation: ", " 0.5s ease-out;\n"], ["\n    display: flex;\n    align-items: center;\n    min-height: 32px;\n    ", "\n    border-radius: 5px;\n    justify-content: space-between;\n    overflow: auto;\n    animation: ", " 0.5s ease-out;\n"])), Theme_1.Color.Grey.Dark, fadeInSlideUp);
var SnackBar = function (_a) {
    var children = _a.children, _b = _a.Visible, Visible = _b === void 0 ? true : _b;
    return (Visible ?
        React.createElement(Container, null, children)
        : null);
};
exports.SnackBar = SnackBar;
var templateObject_1, templateObject_2;
